import { useMemo } from 'react'
import { useMutation } from '@tanstack/react-query'
import { onboardingClient } from '../api'
import type { OnboardingUpdateRequest } from '../types'

export interface UseOnboardingUpdateReturn {
  readonly updateStep: (request: OnboardingUpdateRequest) => void
  readonly updateStepAsync: (request: OnboardingUpdateRequest) => Promise<unknown>
  readonly isUpdating: boolean
  readonly error: string | null
  readonly reset: () => void
}

export function useOnboardingUpdate(): UseOnboardingUpdateReturn {
  const mutation = useMutation({
    mutationFn: onboardingClient.updateOnboarding,
  })

  const errorMessage = useMemo(() => {
    if (mutation.data && 'success' in mutation.data && mutation.data.success === false) {
      return mutation.data.message
    }
    if (mutation.error instanceof Error) {
      return mutation.error.message
    }
    return null
  }, [mutation.data, mutation.error])

  return {
    updateStep: mutation.mutate,
    updateStepAsync: mutation.mutateAsync,
    isUpdating: mutation.isPending,
    error: errorMessage,
    reset: mutation.reset,
  }
}
